/*
 * @Author: junrui_lv junrui_lv@lebo.cn
 * @Date: 2023-02-08 10:33:35
 * @LastEditors: junrui_lv junrui_lv@lebo.cn
 * @LastEditTime: 2023-02-08 10:38:43
 * @FilePath: /web-SaaS/src/components/dragAdjustWidth/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import dragAdjustWidth from './src/main.vue';

dragAdjustWidth.install = function (Vue) {
  Vue.component(dragAdjustWidth.name, dragAdjustWidth);
}

export default dragAdjustWidth;